import { PropsWithChildren, useEffect } from "react";
import twemoji from "twemoji";

export function EmojiProvider({ children }: PropsWithChildren) {
  useEffect(() => {
    const parseTarget = (target: HTMLElement | string) => {
      try {
        twemoji.parse(target, {
          folder: "svg",
          ext: ".svg",
          base: "https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/",
          className: "twemoji",
        });
      } catch (_) {
        // no-op
      }
    };

    // Initial parse
    parseTarget(document.body);

    // Observe DOM changes to parse new content lazily
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type !== "childList") continue;
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          // Skip inputs, textareas, and contenteditable regions
          if (node.tagName === "INPUT" || node.tagName === "TEXTAREA") return;
          if (node.isContentEditable || node.closest("[contenteditable='true']")) return;
          // Avoid reparsing already-parsed emoji images
          if (node.classList.contains("twemoji")) return;
          parseTarget(node);
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  return <>{children}</>;
}

export default EmojiProvider;


